import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom' 
import { getOnlineRegistration } from '../Service/Api';
import LazyLoad from 'react-lazyload';
const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(()=>{
    const getData =async ()=>{
      try {
        let registrationData = await getOnlineRegistration()
        setData(registrationData);

      } catch (error) {
        console.log(error)
      }
    }

    getData()
  },[]) 
  return (
    <>
     
    <div className="OnlineR">
        <span className="bounce1" style={{display:data.length>0?`block`:'none'}}>
        <Link to="https://entab.online/SFSASR" target="_blank" className="parantlogo">
        <LazyLoad>Online Registration</LazyLoad>
        </Link>
       {data.attachments &&( <Link to={`https://webapi.entab.info/api/image/${data.attachments}`} target="_blank" className="parantlogo-attachment"><i className="bi bi-paperclip"></i>  </Link>)}
        
        </span>
    </div> 
      
    </>
  )
}

export default OnlineRegistration
